module.exports = __webpack_public_path__ + "static/img/footer-menu-icon04.cca73dc0.svg";